export default {

    state: {
        users: [],
        inspectors: [],
        states: [],
        vendors: [],
        facilities: [],
        floors: [],
        facility_units: [],
        vacant_units: [],
        details: [],
        category_details: [],
        categories: [],
        concerns: []
    },

    getters: {
        getSelectUsers: state => state.users,

        getSelectInspectors: state => state.users,

        getSelectStates: state => state.states,

        getSelectVendors: state => state.vendors,

        getSelectFacilities: state => state.facilities,

        getSelectFloors: state => state.floors,

        getSelectFacilityUnits: state => state.facility_units,

        getSelectVacantUnits: state => state.vacant_units,

        getSelectInspectionCategoryDetails: state => state.category_details,

        getSelectInspectionDetails: state => state.details,

        getSelectInspectionCategories: state => state.categories,

        getSelectInspectionConcerns: state => state.concerns,
    },

    mutations: {
        setSelectUsers: (state, payload) => {
            state.users = payload;
        },

        setSelectInspectors: (state, payload) => {
            state.users = payload;
        },

        setSelectStates: (state, payload) => {
            state.states = payload;
        },

        setSelectVendors: (state, payload) => {
            state.vendors = payload;
        },

        setSelectFacilities: (state, payload) => {
            state.facilities = payload;
        },

        setSelectFloors: (state, payload) => {
            state.floors = payload;
        },

        setSelectFacilityUnits: (state, payload) => {
            state.facility_units = payload;
        },

        setSelectVacantUnits: (state, payload) => {
            state.vacant_units = payload;
        },

        setSelectInspectionDetails: (state, payload) => {
            state.details = payload;
        },

        setSelectInspectionCategoryDetails: (state, payload) => {
            state.category_details = payload;
        },

        setSelectInspectionCategories: (state, payload) => {
            state.categories = payload;
        },

        setSelectInspectionConcerns: (state, payload) => {
            state.concerns = payload;
        }
    },

    actions: {
        fetchSelectUsers: ({commit}) => {
            return new Promise((resolve, reject) => {
                axios.get('/api/hms/select/users')
                    .then(response => {
                        commit('setSelectUsers', response.data.data);

                        resolve(response.data.data);
                    })
                    .catch(error => {
                        reject(error);
                    });
            });
        },

        fetchSelectInspectors: ({commit}) => {
            return new Promise((resolve, reject) => {
                axios.get('/api/hms/select/inspectors')
                    .then(response => {
                        commit('setSelectInspectors', response.data.data);

                        resolve(response.data.data);
                    })
                    .catch(error => {
                        reject(error);
                    });
            });
        },

        fetchSelectStates: ({commit}) => {
            return new Promise((resolve, reject) => {
                axios.get('/api/hms/select/states')
                    .then(response => {
                        commit('setSelectStates', response.data.data);

                        resolve(response.data.data);
                    })
                    .catch(error => {
                        reject(error);
                    });
            });
        },

        fetchSelectVendors: ({commit}) => {
            return new Promise((resolve, reject) => {
                axios.get('/api/hms/select/vendors')
                    .then(response => {
                        commit('setSelectVendors', response.data.data);

                        resolve(response.data.data);
                    })
                    .catch(error => {
                        reject(error);
                    });
            });
        },

        fetchSelectFacilities: ({commit}) => {
            return new Promise((resolve, reject) => {
                axios.get('/api/hms/select/facilities')
                    .then(response => {
                        commit('setSelectFacilities', response.data.data);

                        resolve(response.data.data);
                    })
                    .catch(error => {
                        reject(error);
                    });
            });
        },

        fetchSelectFloors: ({commit}, facility_id) => {
            return new Promise ((resolve, reject) => {
               axios.get( '/api/hms/select/facility/' + facility_id + '/floors')
                   .then(response => {
                       commit('setSelectFloors', response.data.data);

                       resolve(response.data.data);
                   })
                   .catch(error => {
                       reject(error);
                   })
            });
        },

        fetchSelectFacilityUnits: ({commit}, facility_id) => {
            return new Promise ((resolve, reject) => {
                axios.get('/api/hms/select/facility/' + facility_id + '/units')
                    .then(response => {
                        commit('setSelectFacilityUnits', response.data.data);

                        resolve(response.data.data);
                    })
                    .catch(error => {
                        reject(error);
                    });
            });
        },

        fetchSelectVacantUnits: ({commit}, facility_id) => {
            return new Promise ((resolve, reject) => {
                axios.get('/api/hms/select/facility/' + facility_id + '/vacant-units')
                    .then(response => {
                        commit('setSelectVacantUnits', response.data.data);

                        resolve(response.data.data);
                    })
                    .catch(error => {
                        reject(error);
                    });
            });
        },

        fetchSelectInspectionDetails: ({commit}) => {
            return new Promise((resolve, reject) => {
                axios.get('/api/hms/select/inspections/details')
                    .then(response => {
                        commit('setSelectInspectionDetails', response.data.data);

                        resolve(response.data.data);
                    })
                    .catch(error => {
                        reject(error);
                    });
            });
        },

        fetchSelectInspectionCategoryDetails: ({commit}, category_id) => {
            return new Promise((resolve, reject) => {
                axios.get('/api/hms/select/inspections/categories/' + category_id  + '/details')
                    .then(response => {
                        commit('setSelectInspectionCategoryDetails', response.data.data);

                        resolve(response.data.data);
                    })
                    .catch(error => {
                        reject(error);
                    });
            });
        },

        fetchSelectInspectionCategories: ({commit}) => {
            return new Promise((resolve, reject) => {
                axios.get('/api/hms/select/inspections/categories')
                    .then(response => {
                        commit('setSelectInspectionCategories', response.data.data);

                        resolve(response.data.data);
                    })
                    .catch(error => {
                        reject(error);
                    });
            });
        },

        fetchSelectInspectionConcerns: ({commit}) => {
            return new Promise((resolve, reject) => {
                axios.get('/api/hms/select/inspections/concerns')
                    .then(response => {
                        commit('setSelectInspectionConcerns', response.data.data);

                        resolve(response.data.data);
                    })
                    .catch(error => {
                        reject(error);
                    });
            });
        },
    },

}
